import { FeatureVisibility, IFeature } from '@principle-theorem/feature-flags';

export const AI_RECEPTIONIST_FEATURE: IFeature = {
  label: 'ai-receptionist',
  visibility: FeatureVisibility.Stable,
  permissions: [],
};
